import BootstrapModal from "bootstrap/js/dist/modal";

import { UnshadowedElement, html, render } from "../lib/unshadowed.js";

/** Back button, with prevention modal if form is dirty */
export class BackButton extends UnshadowedElement {
    static elementName() { return "back-button" }

    static properties = {
        href: { type: String },
        text: { type: String },
        /** Don't prompt the user if the form is dirty */
        preventDirtyWatch: { type: Boolean },
        /** Form id to watch for changes */
        dirtyWatch: { type: String },
        buttonClass: { type: String },

        dirty: { state: true, type: Boolean },
    }

    connectedCallback() {
        super.connectedCallback();
        // If there's not already a confirm modal available in the document, add one
        if (!this.preventDirtyWatch && !document.getElementById("modalBackConfirm")) {
            const modal = html`
                <div id="modalBackConfirm" class="modal fade">
                    <div class="modal-dialog modal-minimal modal-sm">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title">Unsaved Changes</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div class="modal-body">
                                <p>Do you want to leave this page? Changes you made will not be saved.</p>
                                <div class="modal-button-row">
                                    <a class="button button-rectangle button-outline">Leave</a>
                                    <button type="button" class="button button-rectangle button-blue" data-bs-dismiss="modal">Stay</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            // Manually render to body. Kludgey, but the modal needs to be outside of the button so we don't get messed up with position: sticky
            render(modal, document.body);
        }

        if (this.preventDirtyWatch) return;

        // Watch for form changes
        let form;
        if (this.dirtyWatch) {
            form = document.getElementById(this.dirtyWatch);
        } else {
            form = this.closest("form");
        }
        if (form) {
            form.addEventListener("change", () => { this.dirty = true; });
            form.addEventListener("pristine", () => { this.dirty = false; });
        }
    }

    Click(e) {
        if (this.dirty) {
            e.preventDefault();
            const modalDiv = document.getElementById("modalBackConfirm");
            if (modalDiv) {
                const anchor = modalDiv.querySelector("a");
                if (anchor) anchor.href = this.href;
                const modal = BootstrapModal.getOrCreateInstance(modalDiv);
                modal.show();
            }
        }
    }

    render() {
        let content;
        if (this.text) {
            content = this.text;
        } else {
            content = html`
                <svg width="9" height="16" fill="none" viewBox="0 0 9 16">
                    <path stroke="#042E53" stroke-miterlimit="10" stroke-width="1.5" d="M9 1 2 8l7 7" />
                </svg>Back
                `;
        }
        return html`
            <a @click=${this.Click} data-wireup-backbutton class="button ${this.buttonClass}" href="${this.href}">${content}</a>
        `;
    }
}
